
import { justLetters } from "../../services/helpers";
function BoxConfirmation({ message, onConfirm, onCancel, loading = false,  inputValue, setInputValue, label ,dependency=null,placeHolder='Escribe aqui el nombre',inUppercase=true,maxLength=dependency?.nombre.length,name=dependency?.nombre}) {
  const onChangeIn = (e) => {
    justLetters(e,inUppercase)
    setInputValue(e.target.value)
  }
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="w-full max-w-md rounded-xl bg-white p-6 shadow-2xl">

        <div className="flex flex-col items-center text-center p-6">
          {/* Icono */}
          <div className="mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-red-100 shadow-sm">
            <span className="text-3xl font-bold text-red-600">!</span>
          </div>

          {/* Título */}
          <h2 className="mb-2 text-2xl font-bold text-gray-800">
            Desactivar
          </h2>

          {/* Mensaje */}
          <div className="flex">
            <p className="mb-6 max-w-md text-sm leading-6 text-gray-600 text-justify ">
            {message} <p className="font-bold text-center text-blue-950">{name}</p>
          </p></div>

          {/* Input */}
          <div className="w-full max-w-md">
            <label
              htmlFor="dependencyName"
              className="mb-2 block text-left text-sm font-medium text-gray-700"
            >
              {label}
            </label>

            <input
              maxLength={maxLength}
              id="dependencyName"
              type="text"
              value={inputValue}
              onChange={(e) => onChangeIn(e)}
              onPaste={(e) => e.preventDefault()}
              onCopy={(e) => e.preventDefault()}
              onCut={(e) => e.preventDefault()}
              placeholder={placeHolder}
              className="
        w-full rounded-lg border border-gray-300
        px-4 py-2 text-gray-700
        placeholder-gray-400
        shadow-sm
        transition
        focus:border-blue-500
        focus:outline-none
        focus:ring-2
        focus:ring-blue-200
      "
            />
          </div>
        </div>

        <div className="mt-6 flex justify-end gap-3">
          <button
            className="cursor-pointer rounded-[10px] bg-gray-200 px-5 py-3 text-gray-700 transition hover:bg-gray-300"
            onClick={onCancel}
            disabled={loading}
          >
            Cancelar
          </button>

          <button
            className="rounded-lg bg-blue-600 px-5 py-2 text-white transition hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-50"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? "Procesando..." : "Confirmar"}
          </button>
        </div>

      </div>
    </div>
  );
}
export default BoxConfirmation;